module.exports = __webpack_public_path__ + "static/media/Twitter.e9ca4eaf.svg";